import { render, staticRenderFns } from "./LottoList.vue?vue&type=template&id=3912dea2&scoped=true"
import script from "./LottoList.vue?vue&type=script&lang=js"
export * from "./LottoList.vue?vue&type=script&lang=js"
import style0 from "./LottoList.vue?vue&type=style&index=0&id=3912dea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3912dea2",
  null
  
)

export default component.exports